// SignUp.jsx
import React, { useState } from 'react';
import './Pages/PagesCss/Auth.css'; // shared auth styles
import { useNavigate } from 'react-router-dom';
import logo from './assets/logo.png';

const SignUp = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', confirm: '' });
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = 'Full name is required';
    if (!form.email) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) newErrors.email = 'Enter a valid email';
    if (!form.password) newErrors.password = 'Password is required';
    else if (form.password.length < 8) newErrors.password = 'Min 8 characters';
    if (!form.confirm) newErrors.confirm = 'Please confirm your password';
    else if (form.confirm !== form.password) newErrors.confirm = 'Passwords do not match';
    if (!acceptPolicy) newErrors.policy = 'You must accept the Terms & Privacy Policy';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    // TODO: handle sign-up logic
    console.log('Sign Up:', form);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const strength = (() => {
    const p = form.password;
    if (!p) return 0;
    let score = 0;
    if (p.length >= 8) score++;
    if (/[A-Z]/.test(p)) score++;
    if (/[0-9]/.test(p)) score++;
    if (/[^A-Za-z0-9]/.test(p)) score++;
    return score;
  })();

  const strengthLabel = ['', 'Weak', 'Fair', 'Good', 'Strong'][strength];
  const strengthClass = ['', 'weak', 'fair', 'good', 'strong'][strength];

  return (
    <div className="auth-page auth-page--signup">
      {/* Left Panel */}
      <div className="auth-panel auth-panel--left">
        <div className="auth-panel__inner">
          <div className="auth-brand" onClick={() => navigate('/')}>
            <img src={logo} alt="QuickPDFs" className="auth-logo" />
            <span className="auth-brand-name"><span className="highlight">Quick</span>PDFs.net</span>
          </div>
          <div className="auth-panel__copy">
            <h2 className="auth-panel__headline">
              Start working smarter<br />with PDFs today.
            </h2>
            <p className="auth-panel__sub">
              Create a free account and unlock 26+ PDF tools no credit card required.
            </p>
            <ul className="auth-features">
              <li><span className="auth-feature-dot" />Free forever no hidden fees</li>
              <li><span className="auth-feature-dot" />Instant access to all 26+ tools</li>
              <li><span className="auth-feature-dot" />Secure files deleted automatically</li>
              <li><span className="auth-feature-dot" />No watermarks on your documents</li>
            </ul>
          </div>
          <div className="auth-panel__stats">
            <div className="auth-stat"><span className="auth-stat-num">26+</span><span className="auth-stat-label">PDF Tools</span></div>
            <div className="auth-stat"><span className="auth-stat-num">5M+</span><span className="auth-stat-label">Files Processed</span></div>
            <div className="auth-stat"><span className="auth-stat-num">100%</span><span className="auth-stat-label">Free Always</span></div>
          </div>
        </div>
      </div>

      {/* Right Panel Form */}
      <div className="auth-panel auth-panel--right">
        <div className="auth-form-wrap">
          <div className="auth-form-header">
            <h1 className="auth-form-title">Create your account</h1>
            <p className="auth-form-sub">Join millions using QuickPDFs.net for free</p>
          </div>

          {/* Social Buttons */}
          <div className="auth-social">
            <button className="auth-social-btn" type="button">
              <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              Sign up with Google
            </button>
            <button className="auth-social-btn" type="button">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.43c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.39-1.32 2.76-2.53 3.96zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              Sign up with Apple
            </button>
          </div>

          <div className="auth-divider"><span>or sign up with email</span></div>

          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            {/* Name */}
            <div className={`auth-field ${errors.name ? 'auth-field--error' : ''}`}>
              <label className="auth-label" htmlFor="signup-name">Full name</label>
              <input
                id="signup-name"
                className="auth-input"
                type="text"
                name="name"
                placeholder="John Doe"
                value={form.name}
                onChange={handleChange}
                autoComplete="name"
              />
              {errors.name && <span className="auth-error-msg">{errors.name}</span>}
            </div>

            {/* Email */}
            <div className={`auth-field ${errors.email ? 'auth-field--error' : ''}`}>
              <label className="auth-label" htmlFor="signup-email">Email address</label>
              <input
                id="signup-email"
                className="auth-input"
                type="email"
                name="email"
                placeholder="you@example.com"
                value={form.email}
                onChange={handleChange}
                autoComplete="email"
              />
              {errors.email && <span className="auth-error-msg">{errors.email}</span>}
            </div>

            {/* Password */}
            <div className={`auth-field ${errors.password ? 'auth-field--error' : ''}`}>
              <label className="auth-label" htmlFor="signup-password">Password</label>
              <div className="auth-input-wrap">
                <input
                  id="signup-password"
                  className="auth-input"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Min. 8 characters"
                  value={form.password}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
                <button type="button" className="auth-eye-btn" onClick={() => setShowPassword(!showPassword)} aria-label="Toggle password">
                  {showPassword ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
              {/* Strength meter */}
              {form.password && (
                <div className="auth-strength">
                  <div className="auth-strength-bars">
                    {[1,2,3,4].map(i => (
                      <div key={i} className={`auth-strength-bar ${i <= strength ? strengthClass : ''}`} />
                    ))}
                  </div>
                  <span className={`auth-strength-label ${strengthClass}`}>{strengthLabel}</span>
                </div>
              )}
              {errors.password && <span className="auth-error-msg">{errors.password}</span>}
            </div>

            {/* Confirm Password */}
            <div className={`auth-field ${errors.confirm ? 'auth-field--error' : ''}`}>
              <label className="auth-label" htmlFor="signup-confirm">Confirm password</label>
              <div className="auth-input-wrap">
                <input
                  id="signup-confirm"
                  className="auth-input"
                  type={showConfirm ? 'text' : 'password'}
                  name="confirm"
                  placeholder="Repeat your password"
                  value={form.confirm}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
                <button type="button" className="auth-eye-btn" onClick={() => setShowConfirm(!showConfirm)} aria-label="Toggle confirm">
                  {showConfirm ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
              {errors.confirm && <span className="auth-error-msg">{errors.confirm}</span>}
            </div>

            {/* Accept Policy */}
            <div className={`auth-check-row ${errors.policy ? 'auth-check-row--error' : ''}`}>
              <label className="auth-checkbox-label">
                <input
                  type="checkbox"
                  className="auth-checkbox-input"
                  checked={acceptPolicy}
                  onChange={() => {
                    setAcceptPolicy(!acceptPolicy);
                    setErrors({ ...errors, policy: '' });
                  }}
                />
                <span className="auth-checkbox-custom" />
                <span className="auth-checkbox-text">
                  I agree to the{' '}
                  <a href="/terms" className="auth-policy-link">Terms of Service</a>
                  {' '}and{' '}
                  <a href="/privacy" className="auth-policy-link">Privacy Policy</a>
                </span>
              </label>
              {errors.policy && <span className="auth-error-msg auth-error-msg--policy">{errors.policy}</span>}
            </div>

            <button className="auth-submit-btn" type="submit">
              Create Free Account
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </form>

          <p className="auth-switch">
            Already have an account?{' '}
            <span className="auth-switch-link" onClick={() => navigate('/signin')}>
              Sign in →
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;